module.exports = __webpack_public_path__ + "img/cate-icon-9.7d52f641.png";